var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h24v24H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M3 9.143V20.57c0 .791.64 1.43 1.429 1.43H21.57c.79 0 1.429-.64 1.429-1.429V9.143H3zm10.714 9.995v.72c0 .196-.16.356-.357.356h-.714a.357.357 0 01-.357-.357v-.728a2.568 2.568 0 01-1.402-.504.357.357 0 01-.027-.541l.527-.5a.363.363 0 01.45-.03c.172.107.37.164.572.165h1.255c.29 0 .527-.264.527-.59 0-.267-.161-.5-.393-.567l-2.01-.602c-.83-.25-1.41-1.045-1.41-1.938 0-1.093.848-1.982 1.906-2.013v-.723c0-.198.16-.357.357-.357h.715c.197 0 .357.16.357.357v.727a2.58 2.58 0 011.402.505.358.358 0 01.026.54l-.522.505a.36.36 0 01-.45.03 1.101 1.101 0 00-.572-.164h-1.255c-.29 0-.526.263-.526.589 0 .268.16.5.392.567l2.01.603c.83.25 1.41 1.044 1.41 1.937-.004 1.094-.857 1.987-1.91 2.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#475B7F",
    d: "M12.286 2H6.888a1.43 1.43 0 00-1.357.978L3.018 7.66c.018.022.022.031.04.053h9.228V2zm8.183.978A1.429 1.429 0 0019.112 2h-5.398v5.714h9.228c.018-.022.022-.031.04-.053L20.47 2.978z"
  }))));
}

export default SvgPlan;